//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "HeaderNotice",
  props: {
    tabs: {
      type: Array,
      default: null,
      required: true
    }
  },
  data: function data() {
    return {
      loadding: false
    };
  },
  methods: {
    fetchNotice: function fetchNotice() {
      var _this = this;

      if (this.loadding) {
        this.loadding = false;
        return;
      }

      this.loadding = true;
      setTimeout(function () {
        _this.loadding = false;
      }, 2000);
    }
  }
};